import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS {
  LANGUAGE = 'language',
  TITLE = 'title',
  BODY = 'body',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.LANGUAGE;

function columns(
  t: TFunction,
  includeActions: boolean,
): IOrderFlexibleColumns[] {
  const main: IOrderFlexibleColumns[] = [
    {
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.LANGUAGE,
      label: t('common.language'),
      key: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.LANGUAGE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.LANGUAGE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.TITLE,
      label: t('common.title'),
      key: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.TITLE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.TITLE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.BODY,
      label: t('common.description'),
      key: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.BODY,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.BODY,
      align: 'left',
      hided: false,
      canHide: false,
    },
  ];
  if (includeActions) {
    main.push({
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.ACTIONS,
      key: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.ACTIONS,
      label: '',
      type: 'string',
      sortable: false,
      sortingKey: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.ACTIONS,
      align: 'right',
      hided: false,
      isFixed: true,
      canHide: false,
    });
  }
  return main;
}

export default function getNotificationTemplateDetailTranslationsTableColumns(
  t: TFunction,
  includeActions: boolean,
): IOrderFlexibleColumns[] {
  return columns(t, includeActions);
}

const hidedColumns: string[] = [];

export const getNotificationTemplateDetailTranslationsDefaultSettings = (
  t: TFunction,
  includeActions: boolean,
) => ({
  columnsOrderIds: columns(t, includeActions)
    .filter((c) => !c.hided && !c.isFixed)
    .map((c) => c.id),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});
